import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {DashboardTools} from './dashboardTools.js';

/* global customElements */
class Dashboard extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var dashboard = this;
		setTimeout(function(){
			dashboard.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var dashboard = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			bodyStyle: 'border-bottom: 1px solid lightgray; height: 42px;',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'addWidget',
					'class': 'spacer-toolbar-item hide',
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add Widgets')
					], 
					listeners: {
						click: function() {
							actionAddWidgets();
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'manageDashboards',
					'class': 'spacer-toolbar-item hide',
					children:[
						ElementUtil.makeIcon('vaadin:list', ' Manage Dashboards')
					], 
					listeners: {
						click: function() {
							actionManageDashboards();
						}
					}
				},				
				{
					tag: 'vaadin-button',
					itemid: 'done',
					theme: 'success primary',					
					'class': 'spacer-toolbar-item hide',				
					children:[
						ElementUtil.makeIcon('vaadin:check', ' Done')
					],
					listeners: {
						click: function() {
							actionSaveDashboard();
						}
					}
				},	
				{
					tag: 'vaadin-button',
					itemid: 'editMode',					
					'class': 'spacer-toolbar-item',
					theme: 'icon',
					style: 'float: right;',
					children:[
						ElementUtil.makeIcon('vaadin:edit', '')
					],
					listeners: {
						click: function() {
							actionEditMode();
						}
					}
				}		
			]
		});	
		
		var innerCSS = ElementUtil.create({
			tag: 'style',
			slot: 'footer',
			innerHTML: `					
				.grid-container-full {
				  display: grid;
				  grid-template-columns: auto auto;
				  gap: 10px;				 
				  padding: 10px;
				}
				
				.grid-container-single {
				  display: grid;
				  grid-template-columns: auto;
				  gap: 10px;
				  padding: 10px;
				}
				
				.grid-item-span-all {
					grid-column: 1/-1;
				}
			
			`
		});			
		
		dashboard.widgetContainer = ElementUtil.create({
			tag: 'div',
			slot: 'primary',
			'class': 'grid-container-full'
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				dashboard.widgetContainer,
				innerCSS
			]
		});		
		dashboard.append(flexLayout);		
			
		const resizeObserver = new ResizeObserver((entries) => {
			if (dashboard.widgetContainer.offsetWidth < 1200) {
				dashboard.widgetContainer.classList.add('grid-container-single');
				dashboard.widgetContainer.classList.remove('grid-container-full');
			} else {
				dashboard.widgetContainer.classList.remove('grid-container-single');
				dashboard.widgetContainer.classList.add('grid-container-full');
			}			
		});
		resizeObserver.observe(dashboard.widgetContainer);
			
		const searchParams = new URLSearchParams(window.location.search);	
		
		var loadDashboard = function() {
			var dashboardId = searchParams.get('id');
			
			Service.getDashboardService().getDashboards().then(function(boards){

				if (dashboardId === 'default') {					
					boards.forEach(function(board){
						if (board.defaultDashboard) {
							dashboard.currentBoard = board;
						}
					});
				} else {
					boards.forEach(function(board){
						if (board.dashboardId === dashboardId) {
							dashboard.currentBoard = board;
						}
					});
					if (!dashboard.currentBoard) {
						//reload dashboard id doesn't exist
						window.location.href = '/view-dash?id=default';
					}					
				}
				dashboard.currentBoard.wigdets = dashboard.currentBoard.widgets || {};	
				if (dashboard.currentBoard.wigdets.length >= 10) {
					ElementUtil.query(toolbar, 'addWidget').disabled = true;
				} else {
					ElementUtil.query(toolbar, 'addWidget').disabled = false;
				}
				renderDashboard(dashboard.currentBoard);					
			});
			
		};
		
		var renderDashboard = function(board, edit) {			
			
			board.widgets = dashboard.currentBoard.widgets || {};	
			
			ElementUtil.removeAllChildren(dashboard.widgetContainer);
			
			dashboard.widgetItems = [];
			board.widgets.forEach(function(widgetConfig){
				
				var widget = ElementUtil.create({
					tag: 'dl-dashboard-widget',
					style: 'height: 400px; border: 1px solid lightgrey;',
					'class': (widgetConfig.columnSpan > 1 ? 'grid-item-span-all' : ''),
					properties: {
						config: widgetConfig,
						firstWidget: (dashboard.widgetItems.length === 0),
						lastWidget: (dashboard.widgetItems.length === dashboard.currentBoard.widgets.length -1) 
					},
					listeners: {
						shift: function(e) {						
							var shiftRight = e.detail.shiftRight;
							
							var newList = [];
							var index = 0;
							var indexOfWidget = 0;
							var widgetToShift;
							dashboard.currentBoard.wigdets.forEach(function(item){
								if (item.order === widgetConfig.order) {
									indexOfWidget = index;
									widgetToShift = item;
								} else {
									newList.push(item);
								}
								index++;
							});
							
							var shiftIndex = indexOfWidget;
							if (shiftRight) {
								shiftIndex++;
							} else {
								shiftIndex--;
							}
							newList.splice(shiftIndex, 0, widgetToShift);
							var order = 1;
							newList.forEach(function(item) {
								item.order = order;
								order++;
							});
														
							dashboard.currentBoard.widgets = newList;
							renderDashboard(dashboard.currentBoard, true);							
						},
						config: function(e) {
							DashboardTools.showWidgetOptions(widgetConfig, {
								configProperties: widgetConfig.configProperties,
								widgetDefinition: widgetConfig,
								handlerApplyConfig: function (data) {									
									renderDashboard(dashboard.currentBoard, true);									
								},
								handlerCancel: function () {
								}
							});
						},
						remove: function(e) {
							
							window.DL.MessageUtil.showConfirm({
								title: 'Confirm Delete',
								message: '<b>Are you sure you want to delete "' + widgetConfig.name + '"?</b><br>Dashboard changes are saved when clicking Done.',
								buttons: [
									{
										text: 'Yes',
										handler: function () {
											var newList = [];
											dashboard.currentBoard.wigdets.forEach(function(item){
												if (item.order !== widgetConfig.order) {																	
													newList.push(item);
												}								
											});
											var order = 1;
											newList.forEach(function(item) {
												item.order = order;
												order++;
											});														
											dashboard.currentBoard.widgets = newList;
											renderDashboard(dashboard.currentBoard, true);
										}
									},
									{
										text: 'No'
									}
								]
							});								
							
						}
					}
				});
								
				dashboard.widgetContainer.append(widget);
				dashboard.widgetItems.push(widget);
				
				if (edit) {
					setTimeout(function() {
						widget.editMode();
					});					
				}
			});						
			
		};
				
		var actionEditMode = function() {
			
			ElementUtil.query(toolbar, 'addWidget').classList.remove('hide');
			ElementUtil.query(toolbar, 'done').classList.remove('hide');
			ElementUtil.query(toolbar, 'manageDashboards').classList.remove('hide');			
			ElementUtil.query(toolbar, 'editMode').classList.add('hide');
		
			dashboard.widgetItems.forEach(function(widget){
				widget.editMode();
			});
			
		};
		
		var getAvailableWidgets = function () {
			var availableWidgets = [];
			availableWidgets.push({
				wigdetId: 'dl-notification-grid',
				name: 'Notifications',
				icon: 'vaadin:bell',
				description: 'Displays in-app notifications',
				properties: {
					local: true
				}
			});
			
			availableWidgets.push({
				wigdetId: 'dl-task-grid',
				name: 'Tasks',
				icon: 'vaadin:check',
				description: 'Task Management',
				permissions: 'COMPANY_BATCH_MANAGEMENT:PAGE,COMPANY_BATCH_MANAGEMENT:READ',
				properties: {
					user: true
				}				
			});			
			
			availableWidgets.push({
				wigdetId: 'dl-import-grid',
				name: 'Import History',
				icon: 'vaadin:upload',
				permissions: 'IMPORTS:PAGE,IMPORTS:READ',
				description: 'Displays import history'			
			});		
			
			availableWidgets.push({
				wigdetId: 'dl-report-grid',				
				name: 'Report History',
				icon: 'vaadin:list',
				permissions: 'REPORTS:PAGE,REPORTS:READ',
				description: 'Displays report history'			
			});
			
			availableWidgets.push({
				wigdetId: 'dl-integration-grid',				
				name: 'Integrations',
				icon: 'vaadin:exchange',
				permissions: 'INTEGRATIONS:PAGE,INTEGRATIONS:READ',
				description: 'Displays data feed status'			
			});			
			
			availableWidgets.push({
				wigdetId: 'dl-node-widget',				
				name: 'Node Status',
				icon: 'vaadin:server',
				permissions: 'ADMIN_SYSTEM:PAGE',
				description: 'Displays node status'			
			});			
			
			var promise = new Promise((resolve, reject) => {
				Service.getUserService().getCurrentUser().then(function(user) {
					
					var filterWidgets = [];
					availableWidgets.forEach(function(widget) {
						
						if (widget.permissions) {
							var valid = false;
							var permissions = widget.permissions.split(',');
							var permissionOp = widget.permissionOp || 'OR';

							if (permissions) {
								if (permissionOp === 'OR') {
									var haveCount = 0;
									permissions.forEach(function (permission) {
										if (user.hasPermission(permission)) {
											haveCount++;
										}
									});
									if (haveCount > 0) {
										valid = true;
									}
								} else {
									var haveCount = 0;
									permissions.forEach(function (permission) {
										if (user.hasPermission(permission)) {
											haveCount++;
										}
									});
									if (haveCount === permissions.length) {
										valid = true;
									}
								}
							} else {
								valid = true;
							}						
							if (valid) {
								filterWidgets.push(widget);
							}							
						} else {
							filterWidgets.push(widget);
						}
					});
					filterWidgets.sort(function(a, b){
						return a.name.localeCompare(b.name); 
					});
					
					resolve(filterWidgets);
				})
				.catch(function() {
					reject();		
				});
			});

			return promise;
		};
		
		var actionAddWidgets = function() {
						
			var widgetWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add Widgets',
				icon: 'vaadin:plus',
				width: 700,
				height: 400,
				listeners: {
					ready: function() {
						widgetWin.show();

						var pickedItem;
						var widgetPicker = ElementUtil.create({
							tag: 'vaadin-list-box',
							slot: 'primary',
							listeners: {
								'selected-changed': function(e) {	
									pickedItem = allWidgets[e.detail.value];
								}
							}
						});
						
						var bottomBar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'footer',
							theme: 'spacing',
							bodyStyle: 'text-align: center',
							children: [
								{
									tag: 'vaadin-button',
									theme: 'primary',
									children:[
										ElementUtil.makeIcon('vaadin:plus', ' Add')
									], 
									listeners: {
										click: function() {											
											if (pickedItem) {																							
												
												var maxOrder = 1;
												dashboard.currentBoard.widgets.forEach(function(widget){
													if (maxOrder < widget.order) {
														maxOrder = widget.order;
													}
												});
												
												var widgetConfig = {
													name: pickedItem.name,
													wigdetId: pickedItem.wigdetId,
													properties: pickedItem.properties,
													titleColor: '#253746',
													titleTextColor: '#ffffff',
													order: ++maxOrder
												};
												DashboardTools.showWidgetOptions(widgetConfig, {
													configProperties: pickedItem.configProperties,
													widgetDefinition: pickedItem,
													handlerApplyConfig: function(data) {
														dashboard.currentBoard.widgets.push(widgetConfig);
														renderDashboard(dashboard.currentBoard, true);
														widgetWin.close();
													},
													handlerCancel: function() {														
													}
												});
												
											} else {
												window.DL.MessageUtil.showOkMessage("Select a Widget to Add.");
											}											
										}
									}
								},
								{
									tag: 'vaadin-button',
									theme: 'tertiary',
									innerHTML: 'Cancel',
									style: 'margin-left: 10px;',
									listeners: {
										click: function () {										
											widgetWin.close();
										}
									}
								}							
							]
						});						
						
						var layout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [							
								widgetPicker,
								bottomBar
							]
						});						
						widgetWin.addToContentElement(layout);
							
						var allWidgets = [];
						getAvailableWidgets().then(function(widgets){
							
							allWidgets = widgets;							
							widgets.forEach(function(widget){
								
								var widgetDesc = '<vaadin-icon icon="' + widget.icon + '"></vaadin-icon> <span style="font-weight: bold; font-size: +1">' + widget.name + '</span><br><span style="color: lightgrey;">' + widget.description + '</span>';
								
								var widgetElement = ElementUtil.create({
									tag: 'vaadin-item',
									style: 'border-bottom: 1px solid lightgrey;',
									innerHTML: widgetDesc,
									properties: {
										widgetConfig: widget
									}
								});
								
								widgetPicker.append(widgetElement);
							});
							
						});	
						
					}
				}
			});			
			
			
		};
		
		var actionManageDashboards = function() {

			var dashboardWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Manage Dashboards',
				icon: 'vaadin:list',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {
						dashboardWin.show();
						
						var toolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'vaadin-button',
									itemid: 'add',
									theme: 'primary',	
									'class': 'spacer-toolbar-item',
									children: [
										ElementUtil.makeIcon('vaadin:plus', ' Add')
									],
									listeners: {
										click: function () {
											actionAddEditDashboard();
										}
									}
								},
								{
									tag: 'vaadin-button',
									itemid: 'edit',
									'class': 'spacer-toolbar-item',
									disabled: true,
									children: [
										ElementUtil.makeIcon('vaadin:edit', ' Edit')
									],
									listeners: {
										click: function () {
											actionAddEditDashboard(grid.selectedItems[0]);
										}
									}
								},
								{
									tag: 'vaadin-button',
									itemid: 'delete',
									theme: 'error primary',					
									'class': 'spacer-toolbar-item',
									style: 'float: right;',
									disabled: true,
									children:[
										ElementUtil.makeIcon('vaadin:trash', ' Delete')
									],
									listeners: {
										click: function() {
											actionDelete(grid.selectedItems[0]);
										}
									}
								}	
							]
						});	
						
						var grid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true,
								listeners: {
									'direction-changed' : function(event) {
										if (event.detail && event.detail.value) {
											grid.currentSortField = event.target.path;
											grid.currentSortDirection = event.detail.value.toUpperCase();										
										}
									}
								}
							},			
							children: [				
								{						
									path: 'name',
									header: 'Name',					
									width: '7em'
								},
								{						
									path: 'defaultDashboard',
									header: 'Default',
									'text-align': 'center',
									width: '7em',
									renderer: function(root, column, rowData) {				
										root.innerHTML = rowData.item.defaultDashboard ? 'True' : '';										
									}
								},												
								{						
									path: 'widgets',
									header: 'Number of Widgets',
									'text-align': 'center',
									width: '7em',
									renderer: function(root, column, rowData) {											
										root.innerHTML = rowData.item.widgets.length;
									}
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									grid.selectedItems = item ? [item] : [];
									if (grid.selectedItems.length > 0) {						
										ElementUtil.query(toolbar, 'edit').disabled = false; 
										if (grid.selectedItems[0].defaultDashboard) {
											ElementUtil.query(toolbar, 'delete').disabled = true;						
										} else {
											ElementUtil.query(toolbar, 'delete').disabled = false;						
										}
									} else {						
										ElementUtil.query(toolbar, 'edit').disabled = true;
										ElementUtil.query(toolbar, 'delete').disabled = true;
									}	
								}
							}
						});	
						
						var layout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [							
								toolbar,
								grid
							]
						});						
						dashboardWin.addToContentElement(layout);						
						
						var nextBoardOrderId = 1;
						var actionRefreshGrid = function() {
							
							var loadMask = grid.showLoading();
							Service.getDashboardService().getDashboards().then(function(boards) {
								loadMask.remove();
								grid.activeItem = null;
								
								boards.forEach(function(board) {
									if (nextBoardOrderId < board.order) {
										nextBoardOrderId = board.order;
									}
								});
								nextBoardOrderId++;		
								
								if (boards.length >= 10) {
									ElementUtil.query(toolbar, 'add').disabled = true;									
								} else {
									ElementUtil.query(toolbar, 'add').disabled = false;									
								}
								
								grid.items = boards;									
							});
						};
						actionRefreshGrid();
						
						var actionRefreshPage = function() {
							window.location.reload();
						};
						
						var actionAddEditDashboard = function(record) {
							var addEditWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: record ? 'Edit' : 'Add',
								icon: 'vaadin:edit',				
								width: 400,
								height: 225,
								listeners: {
									ready: function() {						
										addEditWin.show();

										var formPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',										
													children: [
														{
															tag: 'vaadin-text-field',										
															name: 'name',
															label: 'Name',											
															required: true,
															maxLength: 35											
														},										
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function() {															

																			formPanel.submitForm({
																				preSubmit: function (data) {														
																					return data;
																				},
																				actualCall: function (data) {
																					if (record) {
																						data.dashboardId = record.dashboardId;
																						data.order = record.order;
																						data.widgets = record.widgets;
																					} else {
																						data.order = nextBoardOrderId;
																						data.widgets = [];
																					}
																					return Service.getDashboardService().saveDashboard(data, (record ? true : false));
																				},
																				success: function (data, responseData) {
																					window.DL.MessageUtil.showToast('Success', 'Saved Dashboard', {
																						theme: 'success',
																						position: 'top-stretch'
																					});
																					dashboard.refreshPageOnDone = true;
																					actionRefreshGrid();
																					addEditWin.close();																																										
																				}
																			});

																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			//cancel
																			addEditWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});			

										addEditWin.addToContentElement(formPanel);

										if (record) {
											formPanel.load(record);
										}

									}
								}
							});								
						};
						
						var actionDelete = function(record) {
							window.DL.MessageUtil.showConfirm({
								title: 'Confirm Delete',
								message: '<b>Are you sure you want to delete "' + record.name + '"?</b>',
								buttons: [
									{
										text: 'Yes',
										handler: function () {
											var loadMask = grid.showLoading('Removing...');

											Service.getDashboardService()().deleteDashboard(record.dashboardId)
													.then(function () {
														loadMask.remove();
														window.DL.MessageUtil.showToast('Success', 'Removed ' + record.name, {
															theme: 'success'
														});
														if (dashboard.currentBoard.dashboardId === record.dashboardId) {
															actionRefreshPage();
														} else {
															actionRefreshGrid();
														}														
													});
										}
									},
									{
										text: 'No'
									}
								]
							});
						};

					}
				}
			});

		};
		
		var actionSaveDashboard = function() {
			
			var loadMask = flexLayout.showLoading('Saving...');
			Service.getDashboardService().saveDashboard(dashboard.currentBoard, true).then(function(results) {
				loadMask.remove();
				
				if (dashboard.refreshPageOnDone) {
					window.DL.MessageUtil.showToast('Refreshing', 'Dashboard(s) changes refreshing...');
					window.location.reload();				
				} else {			
					ElementUtil.query(toolbar, 'addWidget').classList.add('hide');
					ElementUtil.query(toolbar, 'done').classList.add('hide');
					ElementUtil.query(toolbar, 'manageDashboards').classList.add('hide');			
					ElementUtil.query(toolbar, 'editMode').classList.remove('hide');
					
					dashboard.widgetItems.forEach(function(widget){
						widget.normalMode();
					});
					
				}
			})
			.catch(function(result){
				loadMask.remove();		
			});
			
		};
		
		loadDashboard();
		
	}
	
};
customElements.define('dl-dashboard', Dashboard);